import React from "react";
import { displayError } from "../utils/errorHandler";

/**
 * Error Boundary компонент для отлова ошибок React
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    
    // Показываем ошибку на весь экран
    displayError(error, {
      type: 'React ErrorBoundary',
      componentStack: errorInfo.componentStack,
    });
    
    // Логируем ошибку (можно отправить на сервер)
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center p-4">
          <div className="max-w-md w-full bg-white dark:bg-gray-800 rounded-2xl shadow-lg border border-gray-200 dark:border-gray-700 p-6">
            <div className="text-center mb-4">
              <div className="text-6xl mb-4">😔</div>
              <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-2">
                Что-то пошло не так
              </h1>
              <p className="text-gray-600 dark:text-gray-400">
                Произошла ошибка при работе приложения
              </p>
            </div>

            {this.state.error && (
              <details className="mb-4">
                <summary className="cursor-pointer text-sm text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300">
                  Показать детали ошибки
                </summary>
                <div className="mt-2 p-3 bg-gray-100 dark:bg-gray-900 rounded-lg overflow-auto max-h-40">
                  <pre className="text-xs text-red-600 dark:text-red-400">
                    {this.state.error.toString()}
                    {this.state.errorInfo && this.state.errorInfo.componentStack}
                  </pre>
                </div>
              </details>
            )}

            <button
              onClick={this.handleReset}
              className="w-full px-4 py-3 bg-blue-500 hover:bg-blue-600 text-white rounded-xl font-medium transition-colors"
            >
              Перезагрузить приложение
            </button>

            <p className="text-xs text-gray-500 dark:text-gray-400 text-center mt-4">
              Если ошибка повторяется, обратитесь к администратору
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
